import React from "react";
import IconButton from "components/common/IconButton";

import SourceIcon from "./SourceIcon";
import {
  AttachmentContainer,
  AttachmentLink,
  AttachmentDetail,
  AttachmentDomain,
  AttachmentTitle,
  AttachmentDomainWrapper,
  PostImage,
  CloseIcon,
  AttachmentDescription,
  AttachmentTextWrapper
} from "./styles";

import EmptyArticleImage from "assets/images/article/empty-article-image.png";

const ArticleAttachment = ({ article, onRemove }) => {
  if (!article || (!article.title && !article.image)) {
    return null;
  }

  const { title, favicon, image, url, domain, description } = article;

  return (
    <AttachmentContainer data-testid="article-attachment" $background={false} $shadow={true}>
      <AttachmentLink href={url} target={"_blank"}>
        <PostImage
          src={image || EmptyArticleImage}
          alt={title}
          className="article"
          onError={e => {
            e.target.onerror = null;
            e.target.src = EmptyArticleImage;
          }}
        />
        <AttachmentDetail>
          <AttachmentDomainWrapper>
            <SourceIcon domain={domain} favicon={favicon} />
            <AttachmentDomain>{domain}</AttachmentDomain>
          </AttachmentDomainWrapper>
          <AttachmentTextWrapper>
            <AttachmentTitle className="underline">{title}</AttachmentTitle>
            {description && (
              <AttachmentDescription>{`${description.slice(
                0,
                70
              )}...`}</AttachmentDescription>
            )}
          </AttachmentTextWrapper>
        </AttachmentDetail>
      </AttachmentLink>
      <CloseIcon>
        <IconButton
          icon={"icon-cancel"}
          variant={"secondaryQuiet"}
          size={28}
          iconSize={18}
          onClick={e => {
            e.stopPropagation();
            onRemove();
          }}
        />
      </CloseIcon>
    </AttachmentContainer>
  );
};

export default ArticleAttachment;
